export const uiStatuspage = {
    name: 'UI Statuspage',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        statuspageId: {
            name: 'Statuspage ID',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ unique: true }]
        },
        none: {
            name: 'None',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        minor: {
            name: 'Minor',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        major: {
            name: 'Major',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        critical: {
            name: 'Critical',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        url: {
            name: 'URL',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    regexp: {
                        pattern: '^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-/]))?$',
                        flags: null
                    }
                }
            ]
        }
    }
};
//# sourceMappingURL=uiStatuspage.js.map